import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../ducks/configureStore';
import { Constants } from '@praktio/common';

// Components
import CATA from '../SlideTypes/CATA/CATA';
import CBS from '../SlideTypes/CBS/CBS';

import './InteractivePanel.scss';
import SupplementalDocument from '../InstructionalPanel/SupplementalDocument/SupplementalDocument';
import { SupplementalDocStates, WindowSizes } from '../../utils/constants';

// Constants
const { TemplateTypes } = Constants;

interface IProps {
  supplementalDoc?: SupplementalDoc;
  panelIds?: string[];
  layoutIsHorizontal: boolean;
  hasLandscapeDoc: boolean;
  hasPortraitDoc: boolean;
  windowSize: WindowSizes;
}

const InteractivePanel = ({
  panelIds,
  layoutIsHorizontal,
  hasLandscapeDoc,
  hasPortraitDoc,
  windowSize,
  supplementalDoc,
}: IProps) => {
  // REDUX STATE
  const { slideType, learnerId } = useSelector((state: RootState) => {
    const { slidesLitmos, learner } = state;
    const { currentSlide } = slidesLitmos;
    const { learnerId } = learner;
    const { type: slideType } = currentSlide || {};

    return {
      slideType,
      learnerId,
    };
  });

  const [supplementalDocState, setSupplementalDocState] = useState(SupplementalDocStates.HalfOpen);

  return (
    <div className="InteractivePanel">
      {/* Supplemental Document */}
      {supplementalDoc && (
        <SupplementalDocument
          supplementalDoc={supplementalDoc}
          learnerId={learnerId}
          mainDocIsLandscape={hasLandscapeDoc}
        />
      )}

      {/* Main Content */}
      {/* CATA */}
      {slideType === TemplateTypes.CheckAllApply && (
        <CATA
          panelIds={panelIds}
          layoutIsHorizontal={layoutIsHorizontal}
          hasLandscapeDoc={hasLandscapeDoc}
          hasPortraitDoc={hasPortraitDoc}
          windowSize={windowSize}
          supplementalDoc={supplementalDoc}
          supplementalDocState={supplementalDocState}
          setSupplementalDocState={setSupplementalDocState}
        />
      )}
      {/* CBS */}
      {slideType === TemplateTypes.ClickBestSpot && (
        <CBS
          panelIds={panelIds}
          hasLandscapeDoc={hasLandscapeDoc}
          hasPortraitDoc={hasPortraitDoc}
          windowSize={windowSize}
          supplementalDoc={supplementalDoc}
          supplementalDocState={supplementalDocState}
          setSupplementalDocState={setSupplementalDocState}
        />
      )}
    </div>
  );
};

export default InteractivePanel;
